<template>
  <div class="userPage">
    <!--    图片-->
    <div class="userPage__picture">
      <div class="box box01">
        <div class="title">隐患统计</div>
        <div class="content">
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{ hiddenNum.unHandledCount || 0 }}</em
              ><span>个</span>
            </div>
            <div class="bom">待处理</div>
          </div>
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{ hiddenNum.todayCount || 0 }}</em
              ><span>个</span>
            </div>
            <div class="bom">当日新增</div>
          </div>
        </div>
      </div>
      <div class="box box02">
        <div class="title">告警统计</div>
        <div class="content">
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{ warningNum.unHandledCount || 0 }}</em
              ><span>个</span>
            </div>
            <div class="bom">待处理</div>
          </div>
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{ warningNum.todayCount || 0 }}</em
              ><span>个</span>
            </div>
            <div class="bom">当日新增</div>
          </div>
        </div>
      </div>
      <div class="box box03">
        <div class="title">能耗统计</div>
        <div class="content">
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{
                deptEnergyNum.thisWeekDeptEnergy || 0
              }}</em
              ><span>{{ deptEnergyNum.unit }}</span>
            </div>
            <div class="bom">
              本周用电
              <em class="theNumStyle"
                >{{
                  deptEnergyNum.oneBeforeWeekSamePeriodDeptRingRatio || 0
                }}%</em
              >
              <img
                :style="deptEnergyNum.upIcon ? '' : 'transform: rotate(180deg)'"
                src="./img/downShape.png"
              />
            </div>
          </div>
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{
                deptEnergyNum.thisMonthDeptEnergy || 0
              }}</em
              ><span>{{ deptEnergyNum.unit2 }}</span>
            </div>
            <div class="bom">
              本月用电
              <em class="theNumStyle">
                {{
                  deptEnergyNum.oneBeforeMonthSamePeriodDeptRingRatio || 0
                }}%</em
              >
              <img
                :style="
                  deptEnergyNum.upIcon2 ? '' : 'transform: rotate(180deg)'
                "
                src="./img/downShape.png"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="box box04">
        <div class="title">设备统计</div>
        <div class="content">
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{ offlineNum.onlineCount || 0 }}</em
              ><span>台</span>
            </div>
            <div class="bom">在线设备</div>
          </div>
          <div class="content__left">
            <div class="num">
              <em class="theNumStyle">{{ offlineNum.offlineCount || 0 }}</em
              ><span>台</span>
            </div>
            <div class="bom">离线设备</div>
          </div>
        </div>
      </div>
    </div>
    <!--    异常处置进度-->
    <box title="异常处置进度" class="userPage__body" over-size>
      <div class="content">
        <div class="content__left">
          <div class="content__left__title">
            您有
            <em class="theNumStyle">{{ hiddenNum.unHandledCount || 0 }} </em
            >个隐患和
            <em class="theNumStyle"> {{ warningNum.unHandledCount || 0 }}</em>
            个报警待处理
          </div>
          <div class="content__left__body">
            <div class="content__left__body__box">
              <div class="chart" ref="chart"></div>
              <div class="down">隐患处置率</div>
            </div>
            <div class="content__left__body__box">
              <div class="chart" ref="chart2"></div>
              <div class="down">警告处置率</div>
            </div>
          </div>
        </div>
        <div class="content__middle samePart">
          <div class="content__title">
            <div class="inLeft">
              <img src="./img/tip.png" />
              <div class="inLeft__word">
                <div class="font">隐患待处置</div>
                <div class="num">
                  <span
                    ><em class="theNumStyle">{{
                      hiddenNum.unHandledCount || 0
                    }}</em></span
                  >个
                </div>
              </div>
            </div>
            <div class="icon">
              <img @click="tohidden()" src="./img/backword.png" />
            </div>
          </div>
          <div class="content__table">
            <el-table
              :data="tableList"
              style="width: 100%"
              :show-header="false"
              class="tableList"
            >
              <el-table-column type="index" class="index">
                <template slot-scope="scope">
                  <div
                    style="
                      width: 20px;
                      height: 20px;
                      color: #ffffff;
                      line-height: 20px;
                      text-align: center;
                      border-radius: 50%;
                      background: #3d82ea;
                    "
                  >
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="riskName"
                label="隐患名称"
                width="120"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="monitorName"
                label="监测名称"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="expireDay"
                label="逾期天数"
                width="80"
                show-overflow-tooltip
              >
                <template slot-scope="scope"
                  ><em class="theNumStyle">{{ scope.row.expireDay }}</em
                  >天</template
                >
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="上报时间"
                width="180"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="content__right samePart">
          <div class="content__title">
            <div class="inLeft">
              <img src="./img/warn.png" />
              <div class="inLeft__word">
                <div class="font">报警待处置</div>
                <div class="num">
                  <span class="theNumStyle">{{
                    warningNum.unHandledCount || 0
                  }}</span
                  >个
                </div>
              </div>
            </div>
            <div class="icon">
              <img @click="towarm()" src="./img/backword.png" />
            </div>
          </div>
          <div class="content__table">
            <el-table
              :data="tableList2"
              style="width: 100%"
              :show-header="false"
              class="tableList"
            >
              <el-table-column type="index" class="index">
                <template slot-scope="scope">
                  <div
                    style="
                      width: 20px;
                      height: 20px;
                      color: #ffffff;
                      line-height: 20px;
                      text-align: center;
                      border-radius: 50%;
                      background: #3d82ea;
                    "
                  >
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="eventName"
                show-overflow-tooltip
                label="原因"
              >
              </el-table-column>
              <el-table-column
                prop="siteName"
                label="名称"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="eventTime"
                label="时间"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </box>
    <!--    设备异常-->

    <box title="设备异常" class="userPage__bottom" over-size>
      <div class="userPage__bottom__body">
        <div class="userPage__bottom__body__title">
          您共有
          <em class="theNumStyle">{{ offlineNum.terminalCount || 0 }}</em>
          台设备，其中
          <em class="theNumStyle">{{ offlineNum.offlineCount || 0 }}</em>
          台处于离线状态，请及时关注是否有故障，以防影响安全监测
        </div>
        <div class="userPage__bottom__body__context">
          <el-table :data="tableList3" ref="sortTable" style="width: 100%" @sort-change="handlechange">
            <el-table-column
              prop="siteNames"
              label="监测点名称"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="imei" label="设备imel" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="offlineTime" label="设备离线时间" >
            </el-table-column>
            <el-table-column prop="offlineLength" label="离线时长" sortable>
              <template slot-scope="scope">
                <em class="theNumStyle"> {{ scope.row.offlineLength || 0 }}</em
                >小时
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="float: right; margin-right: 10px; margin-top: -40px">
        <el-pagination
          @current-change="pageChange"
          background
          :current-page="nowpage"
          :page-size="riskpage"
          layout="total,prev, pager, next, jumper"
          :total="riskSum"
        >
        </el-pagination>
      </div>
    </box>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import box from "../component/box";
import echarts from "echarts";
import axios from "axios";

export default {
  name: "userPage",
  components: { box },
  data() {
    return {
      chart: null,
      chart2: null,
      warningNum: {},
      tableList: [],
      tableList2: [],
      tableList3: [],
      hiddenNum: {},
      offlineNum: {},
      asc:false,
      deptEnergyNum: {
        unit: "",
        unit2: "",
        upIcon: true,
        upIcon2: true,
        thisWeekDeptEnergy: "",
        thisMonthDeptEnergy: "",
        oneBeforeMonthSamePeriodDeptRingRatio: "",
        oneBeforeWeekSamePeriodDeptRingRatio: "",
      },

      nowpage: 1,
      riskpage: 10,
      riskSum: 100,
    };
  },
  computed: {},
  methods: {
    handlechange(column){
      console.log(column)
      // this.$refs.sortTable.clearSort();
      if(column.order=="descending"){
        //降序
        this.asc=false
        this.queryTableList3(false);
      }else if(column.order=="ascending"){
        //升序
        this.asc=true
        this.queryTableList3(true);
      }
    },
    tohidden(){
      this.$router.push("/hiddenWarn");
    },
    towarm(){
      this.$router.push("/electricWarn");
    },
    queryDeptEnergy() {
      let param = {
        method: "post",
        url: "/portal/energyStatis",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.deptEnergy(res.data);
      });
    },
    deptEnergy({
                 thisWeekEnergy,
                 oneBeforeWeekSamePeriodRingRatio,
                 thisMonthEnergy,
                 oneBeforeMonthSamePeriodRingRatio,
    })
    {
      switch (thisWeekEnergy > 10000) {
        case true:
          this.deptEnergyNum.thisWeekDeptEnergy = (
            thisWeekEnergy / 10000
          ).toFixed(2);
          this.deptEnergyNum.unit = "万度";
          break;
        default:
          this.deptEnergyNum.unit = "度";
          this.deptEnergyNum.thisWeekDeptEnergy = thisWeekEnergy;
      }
      switch (thisMonthEnergy > 10000) {
        case true:
          this.deptEnergyNum.thisMonthDeptEnergy = (
            thisMonthEnergy / 10000
          ).toFixed(2);
          this.deptEnergyNum.unit2 = "万度";
          break;
        default:
          this.deptEnergyNum.unit2 = "度";
          this.deptEnergyNum.thisMonthDeptEnergy = thisMonthEnergy;
      }
      this.deptEnergyNum.oneBeforeWeekSamePeriodDeptRingRatio =
        oneBeforeWeekSamePeriodRingRatio;
      if (parseInt(oneBeforeWeekSamePeriodRingRatio) > 0) {
        this.deptEnergyNum.upIcon = false;
      } else {
        this.deptEnergyNum.upIcon = true;
      }
      this.deptEnergyNum.oneBeforeMonthSamePeriodDeptRingRatio =
        oneBeforeMonthSamePeriodRingRatio;
      if (parseInt(oneBeforeMonthSamePeriodRingRatio) > 0) {
        this.deptEnergyNum.upIcon2 = false;
      } else {
        this.deptEnergyNum.upIcon2 = true;
      }
    },
    pageChange(val) {
      this.nowpage = val;
      this.$nextTick(() => {
        this.queryTableList3(this.asc);
      });
    },
    initChart() {
      this.$nextTick(() => {
        this.chart = echarts.init(this.$refs.chart);
        this.chart2 = echarts.init(this.$refs.chart2);
      });
    },
    renderChart(value = 0) {
      if (!this.chart) return;
      const datas = {
        value: 0,
        company: "%",
        ringColor: [
          {
            offset: 0,
            color: "#F38C0E", // 0% 处的颜色
          },
          {
            offset: 1,
            color: "rgba(255, 138, 45, 0)", // 100% 处的颜色
          },
        ],
      };
      const option = {
        title: {
          text: value ? datas.value + datas.company : "--",
          x: "center",
          y: "center",
          textStyle: {
            fontWeight: "normal",
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: "32",
          },
        },
        angleAxis: {
          max: 100, // 满分
          clockwise: false, // 逆时针
          // 隐藏刻度线
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          type: "category",
          // 隐藏刻度线
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        polar: {
          center: ["50%", "50%"],
          radius: "170%", //图形大小
        },
        series: [
          {
            type: "bar",
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "#F38C0E",
                      },
                      {
                        offset: 1,
                        color: "rgba(255, 138, 45, 0.1)",
                      },
                    ]),
                  },
                },
              },
            ],
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: 10,
            barGap: "-100%", // 两环重叠
            z: 2,
          },
          {
            // 灰色环
            type: "bar",
            data: [
              {
                value: 100,
                itemStyle: {
                  color: "#e2e2e2",
                  shadowColor: "rgba(0, 0, 0, 0.2)",
                  shadowBlur: 5,
                  shadowOffsetY: 2,
                },
              },
            ],
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: 10,
            barGap: "-100%", // 两环重叠
            z: 1,
          },
        ],
      };
      this.chart.setOption(option);
    },
    renderChart2(value = 0) {
      if (!this.chart2) return;
      const datas = {
        value: value,
        company: "%",
        ringColor: [
          {
            offset: 1,
            color: "rgba(243, 14, 14, 1)", // 0% 处的颜色
          },
          {
            offset: 0,
            color: "rgba(243, 14, 14, 0)", // 100% 处的颜色
          },
        ],
      };
      const option = {
        title: {
          text: value ? datas.value + datas.company : "--",
          x: "center",
          y: "center",
          textStyle: {
            fontWeight: "normal",
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: "32",
          },
        },
        angleAxis: {
          max: 100, // 满分
          clockwise: false, // 逆时针
          // 隐藏刻度线
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          type: "category",
          // 隐藏刻度线
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        polar: {
          center: ["50%", "50%"],
          radius: "170%", //图形大小
        },
        series: [
          {
            type: "bar",
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "rgba(243, 14, 14, 1)",
                      },
                      {
                        offset: 1,
                        color: "rgba(243, 14, 14, 0.1)",
                      },
                    ]),
                  },
                },
              },
            ],
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: 10,
            barGap: "-100%", // 两环重叠
            z: 2,
          },
          {
            // 灰色环
            type: "bar",
            data: [
              {
                value: 100,
                itemStyle: {
                  color: "#e2e2e2",
                  shadowColor: "rgba(0, 0, 0, 0.2)",
                  shadowBlur: 5,
                  shadowOffsetY: 2,
                },
              },
            ],
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: 10,
            barGap: "-100%", // 两环重叠
            z: 1,
          },
        ],
      };
      this.chart2.setOption(option);
    },
    queryHidden() {
      let param = {
        url: "/portal/sysRiskCountStatis",
        method: "post",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        if (res.data.unHandledCount != 0 || res.data.totalCount != 0) {
          this.hiddenNum = res.data;
          const perce = (res.data.unHandledCount / res.data.totalCount).toFixed(
            1
          );
          this.renderChart(perce);
        } else {
          this.renderChart();
        }
      });
    },
    queryWarnNum() {
      let param = {
        url: "/portal/eventCountStatis",
        method: "post",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        if (res.data.unHandledCount != 0 || res.data.totalCount != 0) {
          this.warningNum = res.data;
          const perce = (res.data.unHandledCount / res.data.totalCount).toFixed(
            1
          );
          this.renderChart2(perce);
        } else {
          this.renderChart2();
        }
      });
    },
    queryTableList() {
      let param = {
        method: "post",
        url: "/portal/getUnHandledRisks",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.tableList = res.data;
      });
    },
    queryTableList2() {
      let param = {
        method: "post",
        url: "/portal/getUnHandledEvents",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.tableList2 = res.data;
      });
    },
    queryOffline() {
      let param = {
        method: "post",
        url: "/portal/terminalOnlineStatis",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.offlineNum = res.data;
      });
    },

    queryTableList3(ascdata) {
      Axios.ajax({
        url: "/portal/findOfflineTerminalPage",
        method: "post",
        data: { pageNum: this.nowpage, showNum: this.riskpage,asc:ascdata,orderColumn:"offlineLength" },
      }).then(({ data }) => {
        this.tableList3 = data.dataList;
        this.riskSum = data.totalNum;
      });
    },
  },
  mounted() {
    this.queryWarnNum();
    this.queryTableList();
    this.queryTableList2();
    this.queryHidden();
    this.queryOffline();
    this.queryDeptEnergy();
    this.$nextTick(() => {
      this.initChart();
    });
    this.queryTableList3(true);
  },
  watch: {
    winWidth() {
      if (this.chart || this.chart2) {
        this.$nextTick(() => {
          this.chart.resize();
          this.chart2.resize();
        });
      }
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.userPage {
  overflow: auto;
  height: 100%;
  width: 100%;
  background-color: #e9ecef;
  padding: 24px;
  &__picture {
    margin: 0px 24px 0px;
    height: 200px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .box {
      width: 22.6vw;
      height: 200px;
      padding: 16px 30px;
      color: #ffffff;
      .title {
        height: 30px;
        font-weight: 500;
        font-size: 20px;
      }
      .content {
        height: 120px;
        display: flex;
        justify-content: space-around;
        align-items: end;
        .content__left {
          height: 90px;
          text-align: center;
          .num {
            font-size: 40px;
            font-weight: bold;
            span {
              margin-left: 10px;
              font-size: 16px;
              font-weight: 500;
            }
          }
          .bom {
            margin-top: 8px;
            font-size: 16px;
            font-weight: 500;
            position: relative;
            img {
              margin-left: 6px;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
    .box01 {
      background-image: url("./img/yellow.png");
      background-repeat: no-repeat;
    }
    .box02 {
      background-image: url("./img/red.png");
      background-repeat: no-repeat;
    }
    .box03 {
      background-image: url("./img/green.png");
      background-repeat: no-repeat;
    }
    .box04 {
      background-image: url("./img/blue.png");
      background-repeat: no-repeat;
    }
  }
  &__body {
    margin-top: 20px;
    .content {
      display: flex;
      overflow: hidden;
      padding: 24px 60px 30px;
      display: flex;
      justify-content: space-between;
      &__left {
        &__title {
          color: rgba(36, 37, 53, 0.85);
          font-size: 14px;
        }
        &__body {
          width: 23.2vw;
          height: 241px;
          background: #f8f8f8;
          border-radius: 5px;
          margin-top: 24px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          &__box {
            width: 6.88vw;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            .chart {
              width: 6.88vw;
              height: 12.22vh;
              margin-bottom: 10px;
            }
          }
        }
      }
      &__middle {
        width: 31.2vw;
        .content__table {
          margin-top: 10px;
          height: 220px;
        }
      }

      &__right {
        width: 31.2vw;
        .content__table {
          margin-top: 10px;
          height: 220px;
        }
      }

      .samePart {
        .content__title {
          height: 64px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .inLeft {
            display: flex;
            align-items: center;
            &__word {
              margin-left: 18px;
              font-size: 14px;
              font-weight: 500;
              span {
                margin-right: 8px;
                font-size: 24px;
                font-weight: bold;
                color: rgba(0, 0, 0, 0.85);
              }
            }
          }
        }
      }
    }
  }
  &__bottom {
    margin-top: 20px;
    margin-bottom: 20px;
    &__body {
      padding: 24px 60px 0;
      &__title {
        margin-bottom: 24px;
      }
      &__context {
        padding-bottom: 50px;
      }
    }
  }
}
.userPage__bottom__body__context {
  .table3 {
    font-size: 14px !important;
    th {
      background-color: rgba(43, 88, 215, 0.04) !important;
    }
    tr {
      height: 53px;
    }
  }
}

.theNumStyle {
  font-family: D-DIN;
}
</style>
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
